export enum LogLevel {
    // Define your log levels here based on your C# LogLevel enum
    // For example:
    Debug = 0,
    Info = 1,
    Warning = 2,
    Error = 3,
    // Add more if needed
}
